// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"68e36ad0","367":"10646eba","453":"8490c504","480":"25c8ba6f","537":"94670eac","555":"699e7ac3","667":"82b40f49","721":"426c8d94","730":"252cb411"}[chunkId] + ".chunk.js";
};